import { useContext } from "react";

import { FrameEditorContext } from "./FrameEditorContext";
import type { FrameEditorContextValue } from "./FrameEditorContext";

export function useFrameEditorContext(): FrameEditorContextValue {
  const context = useContext(FrameEditorContext);

  if (!context) {
    throw new Error(
      "useFrameEditorContext must be used within a FrameEditorProvider",
    );
  }
  return context;
}
